import React from "react";
import signupcheck from "../../images/savecheck.png";
import { NavLink, Navigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { userService } from "../../_services";

function Success_signup() {
    if (!userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/Affiliate_Url" replace />;
    }
    return (
        <div className="flex flex-col items-center justify-center text-center py-16 space-y-4">
            <img src={signupcheck} alt="" className="mb-2 w-20 h-20 object-contain" />
            <p className="text-foreground font-medium">
                You have been registered successfully. Check your email to activate your account.
            </p>
            <p className="text-muted-foreground text-sm">Please be sure to check your spam folder as well!</p>
            <Button variant="secondary" size="lg" className="w-auto" asChild>
                <NavLink to="/login">Sign In Now</NavLink>
            </Button>
        </div>
    );
}

export default Success_signup;
